import React from "react";

const ContactAddress = () => {
  return (
    <div className="xl:max-w-[1163px] pt-[100px] lg:pb-[100px] md:pb-20 sm:pb-16 pb-12 xl:px-0 px-5 container mx-auto">
      <div className="bg-dark-purple lg:px-0 md:px-10 sm:px-8 px-5 rounded-28 md:py-20 sm:py-16 py-12 lg:py-[118px]">
        <div className="max-w-[874px] mx-auto">
          <h2 className="text-white text-center 2xl:text-6xl md:text-5xl sm:text-custom-5xl text-custom-4xl leading-100">
            Smart contract address
          </h2>
          <div className="pt-10">
            <button className="py-[15px] px-[38px] hover:translate-y-2 transition-all duration-300 ease-in-out bg-light-purple rounded-18 border-2 border-dark-purple sm:w-[324px] w-[250px] mx-auto h-[78px] flex items-center justify-center text-white sm:text-custom-4xl text-2xl leading-100 [text-shadow:2px_2px_0px_#000000]">
              COMING SOON
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAddress;
